import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import {
  getCurrentMachine,
  selectTemplatesAsync,
  setBuildShouldCostDetails,
} from 'src/redux/async/ice/buildshouldcostdetails/buildshouldcostdetailsasync'
import { getProjectDetailAsync } from 'src/redux/async/ice/buildshouldcostdetails/projectDetailAsync'

const initialState = {
  details: {
    category: '',
    subcategory: '',
    categoryGroup: '',
    articleDescription: '',
    selectedSKUrow: '',
    doesExist: false,
    project_id: null,
    projectDescription: '',
    projectCountry: 'USA',
    l1: '',
    l2: '',
    l3: '',
    model_creation_date: '',
  },
  projectDetails: {
    detailsLoader: false,
    detailsData: {},
    selectTemplateData: {},
    detailsError: '',
  },
  currentMachineDetails: {},
  materialMachineDetails: [],
  material: {
    currentMaterialId: 0,
  },
  conversion: {
    sectionId: 2,
    defaultList: [
      { name: 'Machine', type: 1 },
      { name: 'Utility', type: 2 },
      { name: 'Labor', type: 3 },
    ],
    newAdded: [],
  },
  specifications: {
    list: [],
  },
  detailsLoader: false,
  detailsError: '',
  projectId: null,
  manufacturingCountry: 'USA',
}

export const buildShouldCostDetailsSlice = createSlice({
  name: 'buildShouldCostDetails',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(setBuildShouldCostDetails.pending), (state) => {
      state.detailsLoader = true
    })

    builder.addMatcher(isAnyOf(setBuildShouldCostDetails.fulfilled), (state, action) => {
      state.detailsLoader = false
      state.details.articleDescription = action.payload.description
      state.details.selectedSKUrow = action.payload.client_primary_id
      state.details.doesExist = action.payload.doesExist || false
      state.details.project_id = action.payload.model_id || null
      state.details.projectDescription = action.payload.model_name || ''
      state.details.projectCountry =
        action.payload.country === 'United States of America'
          ? 'USA'
          : action.payload.country || 'USA'
      state.details.skuId = action.payload.sku_id
      state.details.l1 = action.payload?.l1
      state.details.l2 = action.payload?.l2
      state.details.l3 = action.payload?.l3
      state.details.model_creation_date = action?.payload?.model_creation_date
    })

    builder.addMatcher(isAnyOf(setBuildShouldCostDetails.rejected), (state, action) => {
      state.detailsLoader = false
      state.detailsError = action.payload
    })

    builder.addMatcher(isAnyOf(getProjectDetailAsync.pending), (state) => {
      state.projectDetails.detailsLoader = true
    })
    builder.addMatcher(isAnyOf(getProjectDetailAsync.fulfilled), (state, action) => {
      state.projectDetails.detailsLoader = false
      state.projectDetails.detailsData = action.payload
      state.manufacturingCountry = action.payload.data.recordset.country
    })
    builder.addMatcher(isAnyOf(getProjectDetailAsync.rejected), (state, action) => {
      state.projectDetails.detailsLoader = false
      state.projectDetails.detailsError = action.payload.message
    })
    builder.addMatcher(isAnyOf(selectTemplatesAsync.pending), (state) => {
      state.projectDetails.detailsLoader = true
    })
    builder.addMatcher(isAnyOf(selectTemplatesAsync.fulfilled), (state, action) => {
      state.projectDetails.detailsLoader = false
      state.projectDetails.selectTemplateData = action.payload
    })
    builder.addMatcher(isAnyOf(selectTemplatesAsync.rejected), (state, action) => {
      state.projectDetails.detailsLoader = false
      state.projectDetails.detailsError = action.payload.message
    })
    builder.addMatcher(isAnyOf(getCurrentMachine.fulfilled), (state, action) => {
      state.currentMachineDetails = action.payload.data
    })
    builder.addMatcher(isAnyOf(getCurrentMachine.rejected), (state, action) => {
      state.projectDetails.detailsError = action.payload.message
    })
  },
  reducers: {
    emptyShouldCostDetails: () => initialState,
    emptyProjectDetails: (state) => {
      state.projectDetails.detailsLoader = false
      state.projectDetails.detailsData = {}
      state.projectDetails.detailsError = ''
    },
    emptyConversion: (state) => {
      state.conversion.newAdded = []
    },
    setCurrentMaterial: (state, action) => {
      state.material.currentMaterialId = action.payload
    },
    setMaterialMachine: (state, action) => {
      state.materialMachineDetails = [...action.payload]
    },
    addNewConversion: (state, action) => {
      state.conversion.newAdded = [...action.payload]
    },
    setSpecifications: (state, action) => {
      state.specifications.list = [...action.payload]
    },
    setProjectDetailsExisting: (state, action) => {
      state.projectDetails.detailsData = action.payload
    },
    setProjectId: (state, action) => {
      state.projectId = action.payload
    },
    setManufacturingCountry: (state, action) => {
      state.manufacturingCountry = action.payload
    },
  },
})
export const {
  emptyShouldCostDetails,
  emptyProjectDetails,
  setMaterialMachine,
  setCurrentMaterial,
  addNewConversion,
  setSpecifications,
  setProjectDetailsExisting,
  setProjectId,
  setManufacturingCountry,
} = buildShouldCostDetailsSlice.actions
export default buildShouldCostDetailsSlice.reducer
